import { render, staticRenderFns } from "./utility-nav-btn.vue?vue&type=template&id=0b2fa13a&scoped=true&"
import script from "./utility-nav-btn.vue?vue&type=script&lang=js&"
export * from "./utility-nav-btn.vue?vue&type=script&lang=js&"
import style0 from "./utility-nav-btn.vue?vue&type=style&index=0&id=0b2fa13a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2fa13a",
  null
  
)

export default component.exports